import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"

import Card from "./Card"

const CardList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 65.75rem;
  margin: 0 auto;
  padding: 0 1.25rem;
  list-style: none;
`

const CardListItem = styled.li`
  position: relative;
  display: flex;
  width: 26.2%;
  height: 0;
  padding-top: 31.9%;
  margin: 0 1.5% 8%;

  @media (min-width: 460px) {
    width: 19.68%;
    padding-top: 24%;
    margin-bottom: 6%;
  }

  @media (min-width: 768px) {
    width: 13%;
    padding-top: 15.826%;
    margin-bottom: 3.7%;
  }
`

let flipTimeout

const Game = ({ onTurn, endGame, cards, gameResets }) => {
  const componentIsMounted = useRef(true)
  const [flippedCards, setFlippedCards] = useState([])
  const [foundCards, setFoundCards] = useState([])

  const checkName = (card1, card2) => card1.name === card2.name
  const isFlipped = (card) => flippedCards.find((x) => x.id === card.id)
  const isFound = (card) => foundCards.find((x) => x.id === card.id)

  const handleClick = (card) => {
    clearTimeout(flipTimeout)
    setFlippedCards(flippedCards.length === 2 ? [card] : flippedCards.concat(card))
  }

  useEffect(() => {
    if (gameResets) {
      endGame(true, flippedCards.length || foundCards.length ? 700 : 0)
      setFlippedCards([])
      setFoundCards([])
    }
  }, [gameResets])

  useEffect(() => {
    if (flippedCards.length === 2) {
      onTurn()

      if (!checkName(flippedCards[0], flippedCards[1])) {
        flipTimeout = setTimeout(() => {
          if (componentIsMounted.current) {
            setFlippedCards([])
          }
        }, 1500)
      } else {
        setFoundCards(foundCards.concat(flippedCards))
        setFlippedCards([])
      }
    }
  }, [flippedCards])

  useEffect(() => {
    // All pairs found
    if (foundCards.length === cards.length) {
      endGame(false, flippedCards.length || foundCards.length ? 700 : 0)
      setFlippedCards([])
      setFoundCards([])
    }
  }, [foundCards])

  useEffect(() => {
    return () => {
      componentIsMounted.current = false
    }
  }, [])

  return (
    <CardList>
      {cards.map((card) => (
        <CardListItem key={card.id}>
          <Card
            id={card.id}
            name={card.name}
            pic={card.pic}
            onClick={handleClick}
            isFlipped={isFlipped(card) || isFound(card)}
          />
        </CardListItem>
      ))}
    </CardList>
  )
}

export default Game
